import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { PROCESS_STEPS } from "@/lib/data";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-secondary/30 dark:bg-secondary/10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold mb-4">Our Process</div>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tighter">
            From dream to <span className="font-serif italic text-gradient-royal">departure.</span>
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            A proven 6-step process refined over 1000+ successful admissions.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative">
          {PROCESS_STEPS.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`process-step-${s.n}`}
                className="relative p-8 rounded-3xl bg-card border border-border overflow-hidden group hover:border-[#D4AF37]/60 transition-colors"
              >
                <div className="absolute -top-8 -right-4 text-[10rem] font-serif font-light text-[#0F3D8C]/[0.05] dark:text-white/[0.04] leading-none select-none pointer-events-none">
                  {s.n}
                </div>
                <div className="relative">
                  <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold">Step {s.n}</div>
                  <div className="mt-4 w-12 h-12 rounded-xl bg-[#0F3D8C]/10 dark:bg-[#2563EB]/20 flex items-center justify-center text-[#0F3D8C] dark:text-[#60A5FA] group-hover:bg-[#D4AF37] group-hover:text-white transition-colors">
                    <Icon className="w-6 h-6" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-heading font-semibold text-xl">{s.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
